import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useState } from 'react';
import swal from 'sweetalert';
import Form from "react-validation/build/form";
import APIConfig from "../../../../api/APIConfig";
import {
    Box,
    Center,
    Heading,
    Button,
    Text,
    Alert,
    VStack,
    useColorModeValue,
    FormControl,
    FormLabel,
} from '@chakra-ui/react';


function UploadFotoProfilPeserta() {
    const navigate = useNavigate();
    const [selectedFiles, setSelectedFiles] = useState(undefined);
    const [image, setImage] = useState('');
    const [srcData, setSrcData] = useState('');
    const { id } = useParams();
    const [imageUrl, setImageUrl] = useState(undefined);
    const [validation, setValidation] = useState({});

    function selectFiles(event){
        var fileSelected = event.target.files;

        if(fileSelected.length > 0) {
            var fileToLoad = fileSelected[0];
            setSelectedFiles(fileToLoad);
            setImageUrl(URL.createObjectURL(fileToLoad));
                
            var reader = new FileReader();
    
            reader.onload = function(fileLoadedEvent) {
                setSrcData(fileLoadedEvent.target.result)
            }
            reader.readAsDataURL(fileToLoad)
        }
    }

    const uploadImage = async (e) => {
        e.preventDefault();

        const data = new FormData();
        data.append("file", image);
        data.append("upload_preset", "magangpro")
        data.append("cloud_name", "dlbioqgfd")

        fetch("https://api.cloudinary.com/v1_1/dlbioqgfd/image/upload",{
            method:"post",
            body: data
        })
        .then(() => {
            setSrcData(data.url)
            // preview.src = "data:image/jpg;base64," + dataimage
            console.log("berhasil uploadddd") 
            swal({
                title: "Profil berhasil diubah!",
                icon: "success",
                button: "OK",
            }).then(() => {
                APIConfig.put(`v1/foto/peserta/${id}`, {
                    image: srcData
                }).then(() => {
                    navigate('/peserta/profile');
                    // window.location.reload();
                })
            })
        })
        .catch((error) => {
            console.log(error);
            //assign validation on state
            setValidation(error.response.data);
        })
    }

    return (
        <Center py={6}>
        <VStack justifyItems='left' fontFamily={'Inter'}>
            <Text
                pt={10}
                paddingBottom={10}
                color={'gray.700'}
                fontWeight={600}
                fontSize={'2xl'}
                letterSpacing={1.1}
                fontFamily={'Inter'}>
                Edit Profil
            </Text>
            <Box
                m='10px'
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                justifyContent='left'
                bg={useColorModeValue('white', 'gray.900')}
                rounded={'2xl'}
                p={6}
                overflow={'hidden'}>

                {
                    validation.errors &&
                        <Alert variant="danger">
                            <ul class="mt-0 mb-0">
                                { validation.errors.map((error, index) => (
                                    <li key={index}>{ `${error.param} : ${error.msg}` }</li>
                                )) }
                            </ul>
                        </Alert>
                }

                <Form onSubmit={uploadImage}>
                    <VStack 
                    spacing={4}
                    align='stretch'
                    p={3}
                    fontFamily='Inter'
                    >
                        
                        <Heading
                            mb={6}
                            mt={3}
                            color={useColorModeValue('gray.700', 'white')}
                            fontSize={'xl'}
                            fontFamily={'Inter'}>
                            Edit Foto Profil
                        </Heading>
                        <img style={{width: '20%', height: '20%'}} className="preview" src={imageUrl} alt="" />
                        <FormControl fontFamily={'Inter'}>
                            <FormLabel htmlFor='logo'>Pilih foto</FormLabel>
                            <input 
                                id='logo' className="custom-file-input" 
                                type='file' accept="image/*" 
                                placeholder="Pilih file"
                                value={image}
                                onChange={selectFiles}
                            />
                        </FormControl>
                    </VStack>
                    <Center pt={20}>
                        <Button 
                            disabled={!selectedFiles}
                            type={'submit'}
                            p={6} w='30%' rounded={'xl'} colorScheme='purple' variant='solid'>
                                Simpan
                        </Button>
                    </Center>
                </Form>
            </Box>
        </VStack>
        </Center>
    );
}

export default UploadFotoProfilPeserta;